__turbopack_context__.v({
  "collectionsContainer": "WalletItemFeed-module__OMVTWW__collectionsContainer",
  "root": "WalletItemFeed-module__OMVTWW__root",
});
